import { render, staticRenderFns } from "./Center_infobar.vue?vue&type=template&id=ec648d0a"
import script from "./Center_infobar.vue?vue&type=script&lang=js"
export * from "./Center_infobar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports